import React, { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { FilterMatchMode } from 'primereact/api';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Tooltip } from 'primereact/tooltip';
import { TOOLTIPSTALLED } from '../../../constants';
import { useGetScorecardApprovalActivityQuery } from './scorecardApprovalActivitySlice';
import './ScorecardApprovalActivity.scss'
import { DateTemplate } from '../../../components/dateTemplate/DateTemplate';
import { exportExcel, statusIcon } from './scorecard-approval-activity-service';
import { SCApprovalActivityDetails } from '../scApprovalActivityDetails/SCApprovalActivityDetails';


interface ScorecardAprovalActivityProps {
    inputyear?: number;
    inputmonth?: number;
    scorecardVersion: React.Dispatch<any>;
    activeIndexForTab: React.Dispatch<any>;
    scorecardId: number | string
}

export const ScorecardApprovalActivity = ({
    inputyear,
    inputmonth,
    scorecardVersion,
    activeIndexForTab,
    scorecardId }: ScorecardAprovalActivityProps) => {
    const [scorecardApproalActivity, setScoreCardApproalActivity] = useState<any>(null);
    const [expandedRows, setExpandedRows] = useState<any>();
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [selectedScorecard, setSelectedScorecard] = useState<number>();
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const { data: scorecardApprovalActivity } = useGetScorecardApprovalActivityQuery(
        {
            year: inputyear,
            month: inputmonth,
            scorecardId,

        },
        { skip: !inputyear || !inputmonth }
    );

    const onGlobalFilterChange = (e: any) => {
        const value = e.target.value;
        const afilters = { ...filters };
        afilters.global.value = value;
        setFilters(afilters);
        setGlobalFilterValue(value);
    };
    useEffect(() => {
        if (scorecardApprovalActivity?.data?.length > 0) {
            const data = scorecardApprovalActivity.data.map((item: any) => {
                return {
                    ...item,
                    openDispute: item.open_scorecard_disputes + item.open_metric_disputes
                }
            })
            setScoreCardApproalActivity(data)
        } else {
            setScoreCardApproalActivity([])
        }

    }, [scorecardApprovalActivity]);

    const allowExpansion = (rowData: any) => {
        if (rowData) return true;
        else return false;
    };

    const rowExpansionTemplate = (rowData: any) => {
        return (
            <div className="orders-subtable">
                <SCApprovalActivityDetails inputyear={inputyear} inputmonth={inputmonth} rowscorecardVersionID={rowData.scorecard_version_id} scorecardName={rowData.scorecard_name} />
            </div>
        );
    };

    const statusIndicator = (rowData: any) => {
        const icon = statusIcon(rowData);
        return (
            <div>
                {icon ? (
                    <>
                        <img
                            className="justify-content-left"
                            src={icon}
                            alt={rowData.approvals_paused
                                === 1 ? 'disputed' : 'resolved'}
                        />
                        <Tooltip target=".justify-content-left" position="top">
                            <div id='scapprovalactivity' className="tooltip-content">
                                <span style={{ minWidth: '1rem' }}>
                                    {TOOLTIPSTALLED}
                                </span>
                            </div>
                        </Tooltip>
                    </>

                ) : ('')
                }
            </div>
        );
    };

    const renderHeader = () => {
        return (
            <div className="flex justify-content-between exportexcel">
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText
                        value={globalFilterValue}
                        onChange={onGlobalFilterChange}
                        placeholder="Search"
                    />
                </span>
                <Button
                    type="button"
                    icon="pi pi-arrow-up me-2"
                    className="btn-export mr-2 me-2 float-end"
                    onClick={() => {
                        exportExcel(scorecardApproalActivity);
                    }}
                    data-pr-tooltip="XLS"
                >
                    Export Summary
                </Button>
            </div>
        );
    };

    const textColorCondition = (key: number) => {
        const textColor = key < 75 ? '#E23636' : '#2AA154';
        if (key !== null) {
            return <span style={{ color: textColor }}>{key}{key !== null && '%'}</span>;
        } else {
            return <span>--</span>
        }

    }
    const header = renderHeader();
    const onScorecardClick = (event: any) => {
        if (event.field === 'scorecard_name') {
            const selectedScorecardVersion: any = event?.rowData?.scorecard_version_id;
            setSelectedScorecard(selectedScorecardVersion);
        }
    };
    useEffect(() => {
        if (selectedScorecard) {
            scorecardVersion(selectedScorecard);
            activeIndexForTab(1);
        } else {
            scorecardVersion(undefined);
        }

    }, [selectedScorecard]);

    return (
        <div className="card mt-3 ms-0 me-0 shadow bg-body rounded border-0">
            <div className="card-header border-0" style={{ backgroundColor: '#e0f0ff', padding: '15px', color: '#2B3A42' }}>
                Approval Summary
            </div>
            <div className="card-body p-0 align-middle text-center table">
                <DataTable
                    value={scorecardApproalActivity}
                    header={header}
                    rowExpansionTemplate={rowExpansionTemplate}
                    dataKey='scorecard_version_id'
                    expandedRows={expandedRows}
                    onRowToggle={(e) => {
                        setExpandedRows(e.data);
                    }}
                    className="scoreCardApprovalActivity"
                    rows={5}
                    paginator={scorecardApproalActivity?.length > 5}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    filters={filters}
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    onCellClick={onScorecardClick} cellSelection selectionMode="single"
                >
                    <Column
                        headerStyle={{ width: '1px' }}
                        bodyStyle={{ width: '1px' }}
                        body={statusIndicator}
                    />
                    <Column
                        header="Scorecard"
                        field="scorecard_name"
                        headerStyle={{ fontSize: 14, minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable className="linktext"
                        sortField="scorecard_name"
                    />
                    <Column
                        header="Open Agent Approval"
                        field="approval_window_status_name"
                        headerStyle={{ fontSize: 14, minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        sortField="approval_window_status_name"
                    />
                    <Column
                        header="Window Close Date"
                        field="window_close_date"
                        headerStyle={{ fontSize: 14, minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        body={(date) => date.window_close_date ? DateTemplate(date?.window_close_date) : '--'}
                        sortField="window_close_date"
                    />
                    <Column
                        header="Open Disputes"
                        field="openDispute"
                        headerStyle={{ minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        sortField="openDispute"
                    />
                    <Column
                        header="Associate self-approved"
                        field="assoc_approve_pct"
                        body={(rowData: any) => textColorCondition(rowData.assoc_approve_pct)}
                        headerStyle={{ fontSize: 14, minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        sortField="assoc_approve_pct"
                    />
                    <Column
                        header="TL Total %"
                        field="tl_total_approve_pct"
                        headerStyle={{ fontSize: 14, minWidth: '15rem' }}
                        body={(rowData: any) => textColorCondition(rowData.tl_total_approve_pct)}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        sortField="tl_total_approve_pct"
                    />

                    <Column
                        header="Manager Approved"
                        field="mgr_approve_pct"
                        body={(rowData: any) => textColorCondition(rowData.mgr_approve_pct)}
                        headerStyle={{ fontSize: 14, minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        sortField="mgr_approve_pct"
                    />
                    <Column
                        header="Ready for Extract"
                        field="ready_for_extract_count"
                        headerStyle={{ fontSize: 14, minWidth: '15rem' }}
                        bodyStyle={{ minWidth: '15rem' }}
                        sortable
                        sortField="ready_for_extract_count"
                    />
                    <Column
                        key="expand"
                        expander={allowExpansion}
                        style={{ width: '4em', marginRight: '10px' }}
                    />
                </DataTable>
            </div>
        </div>

    );
};
